import { requestStatusConstants } from 'Integration/integration-util';

export const ADD_MEASUREMENT_API_URL = {
  UPLOAD_SCREEN_LIST: '/pixel/screens/upload',
  VALIDATE_SCREEN_LIST: '/pixel/screens/validate',
  GET_SCREEN_LIST: '/pixel/screens/list',
  GET_MISSING_SCREEN_LIST: '/pixel/screens/missing/list',
  DOWNLOAD_MISSING_SCREEN_LIST: '/pixel/screens/missing',
};

export const initialState = {
  selectedFileCount: 0,
  isEdit: false,
  UPLOAD_SCREEN: {
    status: requestStatusConstants.INITIAL,
    error: null,
    data: null,
    pixelId: null,
  },
  VALIDATE_SCREEN: {
    status: requestStatusConstants.INITIAL,
    error: null,
    data: null,
  },
  GET_SCREEN_LIST: {
    status: requestStatusConstants.INITIAL,
    error: null,
    data: null,
  },
  GET_MISSING_SCREEN_LIST: {
    status: requestStatusConstants.INITIAL,
    error: null,
    data: null,
  },
  DOWNLOAD_MISSING_SCREEN_LIST: {
    status: requestStatusConstants.INITIAL,
    error: null,
    data: null,
  },
};
